import React, { ComponentProps, HTMLAttributes } from 'react';
import { Content } from 'src/styles';
import Notifications from '../PortalList/Notifications';
import {
  Container,
  MvpAppContainer,
  MvpAppTextDocumentsContainer,
  Section,
} from './styles';
import { Title } from './Title';
import { useUrlParameterCheck } from 'src/utils/useUrlParameterCheck';
import { CountryFlagWithLanguage } from '../CountryFlagWithLanguage/CountryFlagWithLanguage';

interface Props extends HTMLAttributes<HTMLElement> {
  title?: string;
  popout?: boolean;
  showNotifications?: boolean;
  className?: string;
  type?: ComponentProps<typeof Container>['type'];
  labelText?: string;
}

export const Card = ({
  className,
  children,
  title,
  popout = false,
  showNotifications,
  type,
  labelText,
  ...rest
}: Props) => {
  const isFromMvpApp = useUrlParameterCheck('/app');

  return (
    <Section popout={popout} className={className} {...rest}>
      <Content>
        {showNotifications && !isFromMvpApp && <Notifications />}
        <>
          {isFromMvpApp ? (
            <MvpAppContainer type={type} data-testid="mvp-card-container">
              <MvpAppTextDocumentsContainer>
                {title ? <Title labelText={labelText}>{title}</Title> : null}
                {children}
              </MvpAppTextDocumentsContainer>
              {showNotifications && isFromMvpApp && <Notifications />}
              <CountryFlagWithLanguage />
            </MvpAppContainer>
          ) : (
            <Container type={type} data-testid="card-container">
              {title ? <Title labelText={labelText}>{title}</Title> : null}
              {children}
            </Container>
          )}
        </>
      </Content>
    </Section>
  );
};
